import { useAction, useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { tradeOrderTypeAtom } from '@root/features/trade/trading/atoms'

import { TradingControlsButtonBase } from '../../desktop/trading-controls-button'

import type { SellControlsModel } from '../../../atoms/common'
import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  model: SellControlsModel
} & ClassNameProps

export const TradingControlsSellButton: React.FC<Props> = ({
  pair,
  className,
  model,
}) => {
  const [swapRequestState] = useAtom(model.executeSwapModel)
  const [quoteState] = useAtom(model.quoteModel.quoteStateAtom)
  const [validation] = useAtom(model.validationAtom)
  const executeSwap = useAction(model.executeSwapModel.execute)
  const [amount] = useAtom(model.inputModel.amountAtom)
  const [tradeOrderType] = useAtom(tradeOrderTypeAtom)

  const createOrder = useAction(model.limitModel.createOrderAction)
  const [createOrderState] = useAtom(model.limitModel.createOrderState)
  const [limitReceiveAmount] = useAtom(model.limitModel.receiveAtom)

  const retryQuote = useAction(model.quoteModel.forceRetry)

  const quoteInputAmount = quoteState.value?.inputAmount
  const quoteOutputAmount = quoteState.value?.outputAmount

  if (tradeOrderType === 'limit') {
    return (
      <Root
        variant="sell"
        onClick={() => createOrder({ settingsOverride: undefined })}
        className={className}
        quoteState={quoteState}
        requestState={createOrderState}
        validation={validation}
        pair={pair}
        amount={amount}
        baseAmount={limitReceiveAmount}
        currencyAmount={quoteInputAmount}
      />
    )
  }

  return (
    <Root
      variant="sell"
      onClick={() => executeSwap()}
      className={className}
      quoteState={quoteState}
      onQuoteRetry={retryQuote}
      requestState={swapRequestState}
      validation={validation}
      pair={pair}
      amount={amount}
      baseAmount={quoteOutputAmount}
      currencyAmount={quoteInputAmount}
    />
  )
}

const Root = styled(TradingControlsButtonBase)``
